// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1675":"2ceff132","2198":"2ceff132","4455":"2ceff132","5894":"c3a6a92f"}[chunkId] + ".chunk.css";
};